<template>
	
	<article class="d-create-login-page">
		<header>
			<h1
				v-if="title || name"
				class="text-[45px] mt-[35px] mb-[10px] font-light"
				v-html="title || name"
			></h1>
			<p
				v-if="teaser"
				class="text-22 <760:text-[14px] mt-[10px] mb-[20px]"
				v-html="teaser"
			></p>

			<div v-if="text" v-html="text" class="w-2/3 <760:w-full text flow mb-[20px]" ></div>
		</header>

		<div v-if="mainForm" class="w-2/3 <760:w-full">
			<div
				v-if="errorMessage"
				class="d-set-password-page__error p-[15px] bg-red text-white mb-[10px]"
			>
				{{ errorMessage }}
			</div>

			

			<form
				v-if="mainForm.endpointUrl && !successMessage"
				:action="action"
				:method="mainForm.method"
				class="w-full p-[25px] bg-white text-16 text-text"
				@submit.prevent="submitForm()"
			>
				<FormText
					v-if="
						mainForm.fields?.length && mainForm.fieldByName.username
					"
					v-model="username"
					:type="mainForm.fieldByName.username.type"
					required
					:placeholder="mainForm.fieldByName.username.placeholder"
					class="w-full mb-[10px]"
				/>
				<FormText
					v-if="mainForm.fieldByName.name"
					v-model="inputName"
					:type="mainForm.fieldByName.name.type"
					required
					:placeholder="mainForm.fieldByName.name.placeholder"
					class="w-full"
				/>
				<div class="text-navy flex justify-end items-center mt-[10px]">
					<BaseButton v-if="mainForm.fieldByName.login" type="submit">
						{{ mainForm.fieldByName.login.label }}
					</BaseButton>
				</div>
			</form>
			<div
				v-else-if="successMessage"
				class="w-full p-[25px] bg-white text-16 text-text"
			>
				<div v-html="successMessage"></div>
			</div>
		</div>

		<BlockList
			:block-list="elements"
			class="w-full mt-[10px] grid grid-cols-1 gap-[10px]"
		/>
	</article>
</template>

<script setup>
const props = defineProps({
	id: Number,
	title: String,
	name: String,
	teaser: String,
	header: Object,
	elements: Array,
	forms: Array,
	links: Array,
	text: String
});
const mainForm = ref(
	props.forms?.length
		? useLimboForm(props.forms[0], { populateFromQuery: true })
		: null
);
</script>
<script>
export default {
	inheritAttrs: false,
	data() {
		return {
			username: '',
			inputName: '',
			errorMessage: null,
			successMessage: null,
			action: null,
		};
	},
	mounted() {
		this.action = this.forms?.[0]?.endpointUrl;
	},
	methods: {
		submitForm() {
			this.errorMessage = null;
			if (this.forms[0].endpointUrl) {
				$fetch(this.forms[0].endpointUrl, {
					method: 'POST',
					body: {
						username: this.username,
						name: this.inputName,
					},
				})
					.then((response) => {
						this.successMessage =
							response ||
							'Du er blevet oprettet. Tjek din mail for at aktivere din bruger og sætte et password.';
					})
					.catch((error) => {
						this.errorMessage = error.data.data?.detail;
					});
			}
		},
	},
};
</script>

<style lang="postcss">
.d-create-login-page {
	@apply text-white flex flex-col justify-center w-full max-w-layout-max pb-[80px] mx-auto px-layout-margin;
	&__error {
		background-image: linear-gradient(#9e0b06, #b7312c);
	}
}
</style>
